import styled from "styled-components";
import Badge from "./Badge";

const Pill = styled(Badge)`
  position: absolute;
  gap: 4px;
  ${({ $top }) => $top !== undefined && `top: ${$top}px;`}
  ${({ $bottom }) => $bottom !== undefined && `bottom: ${$bottom}px;`}
  ${({ $left }) => $left !== undefined && `left: ${$left}px;`}
  ${({ $right }) => $right !== undefined && `right: ${$right}px;`}
  ${({ $centerX }) => $centerX && `left: 50%; transform: translateX(-50%);`}
  background: ${({ $background }) => $background || "rgba(23, 25, 31, 0.85)"};
  border: 1px solid ${({ $borderColor }) => $borderColor || "transparent"};
  backdrop-filter: blur(4px);
  pointer-events: ${({ $interactive }) => ($interactive ? "auto" : "none")};
`;

export default Pill;
